/* eslint-disable */

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";
import IconShare from "../../../ui-components/icon-share/icon-share.js";
import { Size } from "../../../logic/enums.ts";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import RaindropTextHeading2 from "../../../ui-components/raindrop-text-heading-2/raindrop-text-heading-2.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";

const RaindropTipAddToHome = () => {
  return (
    <RaindropPage hasBackNavigation={true}>
      <FlexCol>
        <RaindropTextHeading2>Add To Home Screen</RaindropTextHeading2>
        <RaindropTextSubtitle>
          If you are using an iPhone you can make Raindrop an app on your home
          screen by opening the website on Safari and completing the following
          instructions.
        </RaindropTextSubtitle>
      </FlexCol>

      <div className="flex flex-col w-full items-center gap-5">
        <div className="flex flex-row items-center gap-4 w-full ">
          <h1 className="flex flex-col font-bold   border-2 items-center justify-center rounded-full w-7 h-7">
            1
          </h1>
          <p className="font-bold">Click on the share icon</p>
        </div>

        <div className="w-full max-w-sm">
          <RaindropCard>
            <IconShare className="h-6 fill-color-dark-text-secondary" />
          </RaindropCard>
        </div>
      </div>

      <div className="flex flex-col w-full items-center gap-5 ">
        <div className="flex flex-row items-center gap-4 w-full justify-start">
          <h1 className="flex flex-col font-bold  border-2 items-center justify-center rounded-full w-7 h-7">
            2
          </h1>
          <h1 className="font-bold">Click Add to Home Screen</h1>
        </div>

        <div className="w-full max-w-sm ">
          <RaindropCard additionalClasses="pt-40">
            <RaindropDivider />
            <FlexRow className="p-4">
              <RaindropTextParagraph>Add to Home Screen</RaindropTextParagraph>
              <i className="fa-regular fa-square-plus ml-auto text-xl" />
            </FlexRow>
          </RaindropCard>
        </div>
      </div>

      <div className="flex flex-col gap-5 w-full items-center">
        <div className="flex flex-row items-center justify-start gap-4 w-full ">
          <h1 className="flex flex-col font-bold  border-2 items-center justify-center rounded-full w-7 h-7">
            3
          </h1>
          <h1 className="font-bold">Enjoy</h1>
        </div>
        <div className="w-full max-w-sm">
          <RaindropCard>
            <FlexRow className="justify-center">
              <div className="w-16 h-16 dark:bg-color-dark-background-tertiary bg-color-background-tertiary opacity-60 rounded-lg border-color-dark-border-tertiary" />
              <div className="w-16 h-16 dark:bg-color-dark-background-tertiary bg-color-background-tertiary opacity-60 rounded-lg border-color-dark-border-tertiary" />
              <img
                src="/logo512.png"
                className="w-16 rounded-lg border-color-dark-border-tertiary"
              />
              <div className="w-16 h-16 dark:bg-color-dark-background-tertiary bg-color-background-tertiary opacity-60 rounded-lg border-color-dark-border-tertiary" />
            </FlexRow>
          </RaindropCard>
        </div>
      </div>
    </RaindropPage>
  );
};

export default RaindropTipAddToHome;
